<template>
  <div class="rightModal">
    <NumberInput
      label="servers.ttl"
      placeholder="servers.ttl"
      id="ttl"
      v-model="form.ttl"
      :defaultValue="selected.ttl.toString()"
      :state="validateState('ttl')"
    />
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required, minValue, maxValue } from 'vuelidate/lib/validators'

export default {
  name: 'UpdateTTL',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    selected: String | Object,
    dns_service_id: String,
  },
  data() {
    return {
      form: {
        ttl: '',
      },
    }
  },
  validations: {
    form: {
      ttl: {
        required,
        minValueValue: minValue(120),
        maxValueValue: maxValue(72000),
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        name: this.selected.name,
        type: this.selected.type,
        content: this.selected.content,
        ttl: this.form.ttl,
        // priority:this.selected.priority
      }
      ApiService.put(
        `packetbender/dns/services/${this.dns_service_id}/domains/${this.$route.params.id}/records/${this.selected.id_ref}`,
        params
      )
        .then(({ data }) => {
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>
